/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {endFlow} from '../api'

export const useMutationEndFlow = createReactQueryMutationHook('endFlow', endFlow)
